import React, { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import useWindowSize from '@rooks/use-window-size';

import RichText from '@components/rich-text';
import ChevronIcon from '@components/icons/chevron';
import { WagtailImageBackground } from '@components/image';
import { withSnapPoint } from '@components/snapping-slider';
import { forTabletLandscape } from '@utils/responsive';
import css from './simple-image.module.scss';

const styles = classnames.bind(css);

const SimpleImageSlide = ({ backgroundUrl, backgroundImage, caption, slideRef, active }) => {
    const { innerWidth } = useWindowSize();
    const [autoOpen, setAutoOpen] = useState(true);
    const [buttonActive, setButtonActive] = useState(false);

    // // Open the caption automatically when slide is active.
    useEffect(() => {
        if (autoOpen && active && forTabletLandscape(innerWidth)) {
            setButtonActive(true);
        }
    }, [active]);

    // Stop caption from auto-opening constantly!
    const toggleButton = () => {
        setAutoOpen(false);
        setButtonActive(!buttonActive);
    };

    // If text is empty then don't show caption box
    if (!caption && caption == '' && caption == '<div class="rich-text"></div>') return null;

    return (
        <div ref={slideRef} className={styles('image-slide')}>
            <>
                <div
                    role="figure"
                    aria-roledescription="Image Caption"
                    onClick={toggleButton}
                    className={styles('image-slide__caption', {
                        'image-slide__caption--active': buttonActive,
                    })}
                >
                    <span tabIndex={0} role="button" className={styles('image-slide__caption__label')}>
                        {buttonActive ? 'HIDE CAPTION' : 'SHOW CAPTION'}
                        <ChevronIcon className={styles('image-slide__caption__icon')} />
                    </span>

                    <RichText aria-hidden={!buttonActive} className={styles('image-slide__caption__text')}>
                        {caption}
                    </RichText>
                </div>
            </>

            <WagtailImageBackground
                className={styles('image-slide__background')}
                backgroundUrl={backgroundUrl}
                backgroundImage={backgroundImage}
                style={{
                    animationPlayState: active ? 'running' : 'paused',
                }}
            />
        </div>
    );
};

export default withSnapPoint(SimpleImageSlide);
